module.exports = __webpack_public_path__ + "static/media/29EUNOG11.17aa4752.jpg";